export default __webpack_public_path__ + "static/499-e6b42504c33318a1dec29cfb1a835232.gif";